import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Loading = () => <Skeleton variant="text" width="80%" />;

export default Loading;
